import { App } from 'antd'
import { IntlShape } from 'react-intl'

type NotificationApi = ReturnType<typeof App.useApp>['notification']

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function showApiErrorNotification(notification: NotificationApi, formatMessage: IntlShape['formatMessage'], error: any): void {
  notification.error({
    message: formatMessage({ id: 'error.generic' }),
    description: error?.response?.data?.message || error?.message,
    duration: 0,
  })
}
